/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { ElementRef, Renderer2, RendererFactory2, Component, Inject, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { IcepanelComponent } from './icepanel.component';
import { Iceutility } from '../../services/iceutility';
import { iceColumnDefinition, IcecontrolPermission } from 'projects/icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../login/login.config';
import { tablebasecomponent } from '../icepanel/tablebasecomponent';
import { MatSort } from '@angular/material';

@Component({
  selector: 'icemattableresponsivedesktopedit',
  templateUrl: './icemattableresponsivedesktopedit.component.html',
  styleUrls: ['./icepanelcontainer.component.scss']
})
export class IceMattableResponsiveDesktopEditComponent extends tablebasecomponent implements OnInit {
  permission: IcecontrolPermission = null;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(IcepanelComponent) parent: IcepanelComponent,
    private rendererFactory: RendererFactory2,
    private targetRef: ElementRef) {
    super(parent);
  }

  getColumns(): iceColumnDefinition[] {
    if (this.ctrl == null) return [];
    let columns = this.ctrl.getColumns();
    for (let c = 0; c < columns.length; c++) {
      if (!columns[c].important) {
        columns[c].hidden = true;
      }
    }
    return columns;
  }

  ngOnInit() {
    this.permission = this.ctrl.permissions ? this.ctrl.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);
  }

  ngAfterViewInit() {
    let parent: any = this.getParentPanel();

    setTimeout(_ => {
      parent.panelSvc.matSortChangeSubject.subscribe(data => {
        if (data === "reset") {
          this.sort.sort({
            id: '',
            start: 'asc',
            disableClear: true
          });
          //default sort direction
          this.sort.direction = '';
        }
      });
    }, 200);
  }

  onRowClick(event, rowData) {
    event.matTableSettings = this.ctrl;
    this.selectedRowData = rowData;
    if (Iceutility.isdefined(event) &&
      event.target.hasAttribute("mat-button") || event.target.className.constructor.name === "SVGAnimatedString") {
      return;
    } else if (this.enableRowSelection) {
      let elements = document.getElementsByClassName("selected-row");
      if (Iceutility.isdefined(elements) && elements.length > 0) {
        for (var ielem = 0; ielem < elements.length; ielem++) {
          var elem = elements[ielem];
          if (elem === null) {
            continue;
          }

          elem.classList.remove("selected-row");
        }
      }

      let renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);
      renderer.addClass(event.currentTarget, "selected-row");
    }

    event.rowData = rowData;
    let parent: IcepanelComponent = this.getParentPanel();
    if (parent && parent.matgridRowClick)
      parent.onMatGridRowClick(event);
    else
      this.rowClick.emit(event);

    // emit to control observers
    if (this.ctrl.rowClickEvent != null) {
      this.ctrl.rowClickEvent.emit(event);
    }
  }

  onColumnClick(event, colDef, rowData) {
    event.matTableSettings = this.ctrl;
    event.colDef = colDef;
    event.rowData = rowData;
    this.selectedRowData = rowData;

    let parent: IcepanelComponent = this.getParentPanel();
    if (parent && parent.matgridColClick)
      parent.onMatGridColClick(event);
    else
      this.colClick.emit(event);
  }

  onRowActionButtonClick(event, item: any, rowData: any) {
    event.matTableSettings = this.ctrl;
    event.rowData = !Iceutility.isdefined(this.rowData) ? rowData : this.rowData;
    event.actionItem = item;

    let parent: IcepanelComponent = this.getParentPanel();
    if (parent && parent.matgridRowActionClick)
      parent.onMatGridRowActionClick(event);
    else
      this.rowActionClick.emit(event);
  }

  onAddRowButtonClick(event) {
    event.matTableSettings = this.ctrl;
    let parent: IcepanelComponent = this.getParentPanel();
    if (parent && parent.matgridAddRowButtonClick)
      parent.onMatGridAddRowButtonClick(event);
    else
      this.addRowButtonClick.emit(event);
  }

  hasAccess(): boolean {
    if (this.permission == null) return true;

    return (this.permission.default_access !== userTypes.USER_FEATURE_ACCESS.ufaNone || this.permission.feature === userTypes.USER_FEATURES.ufNone);
  }
}
